import { useRepositories } from '../../../contexts';
import { useAppQuery } from '../utils';
export var useGetFastMealScheduleApi = function (familyId, isEnabled) {
    if (isEnabled === void 0) { isEnabled = true; }
    var familyRepo = useRepositories().familyRepo;
    var queryKey = ['getFastMealSchedule', familyId];
    return useAppQuery(queryKey, function () {
        if (!familyId)
            throw new Error('Family ID is required');
        return familyRepo.getFastMealSchedule(familyId);
    }, {
        enabled: !!familyId && isEnabled,
    });
};
